import React from 'react'
import '../Order/orders.css'
import Button from '../../../Components/commonButton/commonButton'
import Api from '../../../services/api'
import ReadOnlyTextField from '../../../Components/readOnlyTextField/readOnlyTextField'
import Alert from '../../../Components/alert/Alert'
import '../general.css'
import Select from '../../../Components/select/select';
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";

export default class altOp extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id:null,arrayWorkShifts:[],initHour:null,finalHour:null,arr_idcodes:[],description:"",
            show: false,
            message:"",
            notification: false,
            notification_type: 'success',
            notification_message: '',
        }
    }

    componentDidMount() {
        Api.get('/work-shifts/').then((resp) => {
            let arr_codes = []
            let arr_ids = []
            resp.data.forEach(element => {
                arr_codes.push({ value: element.id, label:element.code })
                arr_ids.push({ id: element.id, code: element.code })
            });
            this.setState({ arrayWorkShifts: arr_codes, arr_idcodes: arr_ids })
        }).catch((error) => {
            if (error.response) {
                this.setState({show: true, message: "Erro ao deletar turno!"});
            }
        })    
    }

    changeValueCode = (data) => { 
        const {id} =  this.state.arr_idcodes.find(value => value.id === data)
        
        Api.get(`/work-shifts/${id}`).then(resp=>{
            const {id,code,start_time,end_time} = resp.data
            this.setState({id:id,description:code,initHour:start_time,finalHour:end_time})
        }).catch(err=>{
            this.setState({show: true, message: "Erro ao deletar turno!"});
        })
    }

    changeValueInitHour = (data) => { this.setState({ initHour: data }) }
    changeValueFinal    =  (data) => { this.setState({ finalHour: data })}

    sendData = () => {
        if(this.state.id !== null){
            Api.delete(`/work-shifts/${this.state.id}`).then((resp) => {
                this.setState({notification: true, notification_message: "Turno deletado com sucesso!"});
                setTimeout(()=>{
                    return window.location.reload();
                },2000)
            }).catch(error => {
                if(error.response.status == 401){
                    this.setState({show: true, message: "Erro ao deletar! Uma máquina depende desse registro."});
                }
                if(error.response.status == 402){
                    this.setState({show: true, message: "Erro ao deletar! Um funcionário depende desse registro."});
                }
                if (error.response.status != 401 && error.response.status != 402) {
                    this.setState({show: true, message: "Erro ao deletar turno!"});
                }
            })
        }else{
            this.setState({show:true,message:"Selecione o turno."})
        }
    }

    callbackfunction = () => { this.setState({ show: false }) }

    render() {
        let {show,message, notification, notification_message, notification_type} = this.state
        return (
            <div className="box">
                {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
                <div className="mot_del_reason form" >
                <h4>Deletar Turno</h4>
                    {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} /> : null}
                    <div className='inputs'>
                        <div className='select element'><Select autoSelect={true} label="Turno" arrData={this.state.arrayWorkShifts} handleSelect={this.changeValueCode} /></div>
                        <div className='element'><ReadOnlyTextField title="Descrição" showValue={this.state.description} /></div>
                        <div className='element'><ReadOnlyTextField title="Hora de início" showValue={this.state.initHour} /></div>
                        <div className='element'><ReadOnlyTextField title="Hora de término" showValue={this.state.finalHour} /></div>
                    </div>
                    <div className='btnDelWorkShift submitButton'><Button icon="del" title="Deletar" parentCallback={this.sendData} /></div>
                </div>
            </div>
        );
    }
}
